import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/next/app/components/homeWithSplash.tsx");
